/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 抖音订单状态检查
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  showId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: number;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/douYinStatusCheck/${showId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
